module.exports = __webpack_public_path__ + "img/Uruguay.4bb09fe9.png";